import { configureStore } from '@reduxjs/toolkit';

import { appSlice, authSlice, mailSlice, memberSlice, projectChatSlice, rolesSlice } from '@/redux/slices';
import { expertSlice } from '@/redux/slices/expert.slice';
import { overviewSlice } from '@/redux/slices/overview.slice';
import { projectSlice } from '@/redux/slices/project.slice';

export const store = configureStore({
  reducer: {
    [appSlice.name]: appSlice.reducer,
    [authSlice.name]: authSlice.reducer,
    [projectSlice.name]: projectSlice.reducer,
    [rolesSlice.name]: rolesSlice.reducer,
    [memberSlice.name]: memberSlice.reducer,
    [expertSlice.name]: expertSlice.reducer,
    [overviewSlice.name]: overviewSlice.reducer,
    [mailSlice.name]: mailSlice.reducer,
    [projectChatSlice.name]: projectChatSlice.reducer,
  },
});
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
